import { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useFeedbackEnabled } from './hooks/useFeedbackEnabled';
import { FeedbackDialog } from './FeedbackDialog';
import {
  initFeedbackTracker,
  destroyFeedbackTracker,
  trackNavigation,
} from './utils/feedbackTracker';
import { Icon } from '@/components/primitives/icon/Icon';

export function FeedbackFAB() {
  const enabled = useFeedbackEnabled();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const prevPathRef = useRef(location.pathname);

  const isMobileRoute = location.pathname.startsWith('/mobile');

  useEffect(() => {
    initFeedbackTracker();
    return () => destroyFeedbackTracker();
  }, []);

  useEffect(() => {
    if (location.pathname !== prevPathRef.current) {
      trackNavigation(location.pathname);
      prevPathRef.current = location.pathname;
    }
  }, [location.pathname]);

  if (!enabled || isMobileRoute) return null;

  return (
    <>
      {!open && (
        <button
          data-feedback-fab
          onClick={() => setOpen(true)}
          className="fixed bottom-6 right-6 z-[9990] flex h-12 w-12 items-center justify-center rounded-full bg-red-600 text-white shadow-lg transition-all hover:bg-red-700 hover:shadow-xl active:scale-95"
          title="Send feedback"
        >
          <Icon name="robotfilled" size={28} className="fill-white" />
        </button>
      )}
      <FeedbackDialog open={open} onOpenChange={setOpen} />
    </>
  );
}
